import { editorPicks } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function EditorPicks() {
  return (
    <section id="buzz" className="w-full border-t border-background-200 bg-background-100/70">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <SectionHeading
          kicker="EDITOR'S NOTE"
          title="编辑手记"
          desc="关于内容怎么选、怎么标、怎么排，我们把想法摆在这里。"
          actionLabel="更多手记"
          actionHref="#buzz"
        />

        <ol className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-2 lg:grid-cols-5">
          {editorPicks.map((item, index) => (
            <li key={item.id} className="bg-background-50">
              <a href="#buzz" className="group flex h-full cursor-pointer flex-col p-5 transition-colors hover:bg-accent-50">
                <span className="font-heading text-3xl font-black text-background-300 transition-colors group-hover:text-accent-400">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-3 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.note}</p>
                <span className="mt-4 text-[11px] text-foreground-500">{item.date}</span>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}